/** Winners board routes (§12.3, §16.2) — registered through the append-only registry (docs/modules/console.md). */
import type { ConsoleRoute } from '../index';
import { WinnerDetailPage } from './WinnerDetailPage';
import { WinnersBoardPage } from './WinnersBoardPage';

export const winnersRoutes: ConsoleRoute[] = [
  {
    path: 'winners',
    handle: { permission: 'winners.view', title: 'Winners board' },
    element: <WinnersBoardPage />,
  },
  {
    path: 'winners/lookup/:winId',
    handle: { permission: 'winners.lookup', title: 'Win ID lookup' },
    element: <WinnerDetailPage />,
  },
];
